/**
 * Responsive Images Module
 * Handles responsive background images based on viewport size
 */

// Breakpoints matching SCSS variables
const BREAKPOINTS = {
    mobile: 575,
    tablet: 991
};

/**
 * Get the current viewport category
 * @returns {string} 'mobile', 'tablet', or 'desktop'
 */
const getViewportSize = () => {
    const width = window.innerWidth;

    if (width <= BREAKPOINTS.mobile) {
        return 'mobile';
    } else if (width <= BREAKPOINTS.tablet) {
        return 'tablet';
    } else {
        return 'desktop';
    }
};

/**
 * Set responsive background image for an element
 * @param {HTMLElement} element - The element to set background on
 */
const setResponsiveBackground = (element) => {
    const viewportSize = getViewportSize();
    const bgMobile = element.getAttribute('data-bg-mobile');
    const bgTablet = element.getAttribute('data-bg-tablet');
    const bgDesktop = element.getAttribute('data-bg-desktop');

    // Determine which image to use
    let bgImage;
    if (viewportSize === 'mobile' && bgMobile) {
        bgImage = bgMobile;
    } else if (viewportSize === 'tablet' && bgTablet) {
        bgImage = bgTablet;
    } else if (bgDesktop) {
        bgImage = bgDesktop;
    }

    // Set background image if we have one
    if (bgImage) {
        element.style.backgroundImage = `url('${bgImage}')`;
        console.log(`Set ${viewportSize} background:`, bgImage);
    }
};

/**
 * Initialize responsive background images
 * @param {NodeList|Array} elements - Elements with responsive background data attributes
 */
export const initResponsiveBackgrounds = (elements) => {
    if (!elements || elements.length === 0) return;

    // Set initial backgrounds
    elements.forEach(element => {
        setResponsiveBackground(element);
    });

    // Handle resize with debouncing
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            elements.forEach(element => {
                setResponsiveBackground(element);
            });
        }, 250);
    }, { passive: true });
};

/**
 * Initialize all responsive images on the page
 */
export const initResponsiveImages = () => {
    // Find all elements with responsive background data attributes
    const elementsWithBgData = document.querySelectorAll('[data-bg-mobile], [data-bg-tablet], [data-bg-desktop]');

    if (elementsWithBgData.length > 0) {
        console.log(`Initializing responsive backgrounds for ${elementsWithBgData.length} elements`);
        initResponsiveBackgrounds(elementsWithBgData);
    }
};
